import Logo from '@static/icons/logo.svg';

export const navigationLinks = [
  {
    name: 'Immobilienverkauf',
    link: { url: '/verkaufen' },
    children: [
      {
        name: 'Haus verkaufen',
        link: { url: '/verkaufen/privates-haus-verkaufen' },
      },
      {
        name: 'Eigentumswohnung verkaufen',
        link: { url: '/verkaufen/eigentumswohnung-verkaufen' },
      },
      {
        name: 'Grundstück verkaufen',
        link: { url: '/verkaufen/grundstueck-verkaufen' },
      },
      {
        name: 'Maklerprovision',
        link: { url: '/verkaufen/maklerprovision' },
      },
      {
        name: 'Spekulationssteuer bei Immobilien',
        link: { url: '/verkaufen/spekulationssteuer-immobilien' },
      },
      {
        name: 'Energieausweis',
        link: { url: '/verkaufen/energieausweis' },
      },
    ],
  },
  {
    name: 'Immobilienbewertung',
    link: { url: '/immobilienbewertung' },
    children: [
      {
        name: 'Immobiliengutachter',
        link: { url: '/immobilienbewertung/immobiliengutachter' },
      },
      {
        name: 'Immobilienwertrechner',
        link: { url: '/immobilienbewertung/immobilienwertrechner' },
      },
      {
        name: 'Hauswert',
        link: { url: '/immobilienbewertung/hauswert' },
      },
      {
        name: 'Haus schätzen lassen',
        link: { url: '/immobilienbewertung/haus-schaetzen-lassen' },
      },
      {
        name: 'Grundstücksbewertung',
        link: { url: '/immobilienbewertung/grundstuecksbewertung' },
      },
      {
        name: 'Verkehrswert',
        link: { url: '/immobilienbewertung/verkehrswert' },
      },
    ],
  },
  {
    name: 'Immobilien kaufen',
    link: { url: '/immobilien' },
    children: [
      {
        name: 'Immobilienangebote',
        link: { url: '/immobilien' },
      },
      {
        name: 'Immobilienpreise',
        link: { url: '/immobilienpreise' },
      },
      {
        name: 'Grunderwerbsteuer sparen',
        link: { url: '/ratgeber/immobilienkauf/grunderwerbsteuer-sparen' },
      },
      {
        name: 'Tipps zur Immobiliensuche',
        link: { url: '/ratgeber/immobilienkauf/immobiliensuche' },
      },
      {
        name: 'Eigentumswohnung kaufen',
        link: { url: '/ratgeber/immobilienkauf/eigentumswohnung-kaufen' },
      },
      {
        name: 'Ratgeber Immobilienkauf',
        link: { url: '/ratgeber/immobilienkauf' },
      },
      {
        name: 'Käufercourtage',
        link: { url: '/ratgeber/immobilienkauf/kaeufercourtage' },
      },
      {
        name: 'Zwangsversteigerungen Immobilien',
        link: { url: '/ratgeber/immobilienkauf/zwangsversteigerungen-immobilien' },
      },
    ],
  },
  {
    name: 'Baufinanzierung',
    link: { url: '/finanzierung' },
    children: [
      {
        name: 'Baufinanzierungsrechner',
        link: { url: '/finanzierung/baufinanzierungsrechner' },
      },
      {
        name: 'Aktuelle Bauzinsen',
        link: { url: '/finanzierung/aktuelle-bauzinsen' },
      },
      {
        name: 'Hausfinanzierung',
        link: { url: '/finanzierung/hausfinanzierung' },
      },
      {
        name: 'Wohnungsfinanzierung',
        link: { url: '/finanzierung/wohnungsfinanzierung' },
      },
      {
        name: 'Anschlussfinanzierung',
        link: { url: '/finanzierung/anschlussfinanzierung' },
      },
      {
        name: 'Ratenkredit',
        link: { url: '/finanzierung/ratenkredit' },
      },
      {
        name: 'Staatliche Förderung',
        link: { url: '/finanzierung/foerderung' },
      },
    ],
  },
  {
    name: 'Research',
    link: { url: '/research' },
    children: [
      {
        name: 'McMakler Magazin',
        link: { url: '/magazin' },
      },
      {
        name: 'Marktdaten & Kaufpreise',
        link: { url: '/research/marktdaten-kaufpreise/' },
      },
      {
        name: 'Umfragen & Trends',
        link: { url: '/research/umfragen-trends' },
      },
      {
        name: 'Politik & Regulierung',
        link: { url: '/research/politik-und-regulierung' },
      },
      {
        name: 'Immobilienlexikon',
        link: { url: '/immobilienlexikon' },
      },
    ],
  },
  {
    name: 'Standorte',
    link: { url: '/standorte' },
    children: [
      {
        name: 'Alle Standorte',
        link: { url: '/standorte' },
      },
      {
        name: 'Immobilienmakler Berlin',
        link: { url: '/standorte/berlin' },
      },
      {
        name: 'Immobilienmakler München',
        link: { url: '/standorte/muenchen' },
      },
      {
        name: 'Immobilienmakler Hamburg',
        link: { url: '/standorte/hamburg' },
      },
      {
        name: 'Immobilienmakler Köln',
        link: { url: '/standorte/koeln' },
      },
      {
        name: 'Immobilienmakler Frankfurt',
        link: { url: '/standorte/frankfurt' },
      },
      {
        name: 'Immobilienmakler Stuttgart',
        link: { url: '/standorte/stuttgart' },
      },
    ],
  },
];

export const logo = {
  image: { name: 'McCompass', filename: Logo, alt: 'McCompass' },
  url: { url: '/' },
  width: '130px',
};
